<!-- Base template for components -->
<template>
    <div class="text-center">
        <p-button 
            class="p-button-sm" 
            v-if="!tutorial_on" 
            @click="dialog = true" 
            icon="pi pi-book" 
            aria-label="Guide" 
            title="Guide me" 
        />
        <p-button 
            class="p-button-lg exit-button" 
            v-if="tutorial_on" 
            @click="exitTutorial" 
            icon="pi pi-sign-out"
            label="Exit Tutorial" 
            aria-label="Guide" 
            title="Guide me" 
        />
    </div>
    <p-dialog  
    v-model:visible="dialog" 
    modal position="bottomleft" 
    header="Tutorials" :style="{ width: '700px' }">
        <div style="height:400px;">
            <ul>
                <li><a href="/masters?tutorial=create_email">Sending and Tracking Messages</a></li>
                <li><a href="/masters?tutorial=business_rule">Route responses with Business Rules</a></li>
            </ul>
        </div>
    </p-dialog>
</template>
  
<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class TutMon extends Vue {
    msg!: string
    dialog = false
    tutorial_on = false


    mounted(){
        // eslint-disable-next-line
        // @ts-ignore
        this.tutorial_on = this.$route.query?.tutorial?.length > 0
    }

    exitTutorial(){
        window.location = "?" as any
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .exit-button {
        position:fixed;
        bottom:5px;
        left:5px;
    }
</style>
